import http from '../http'

const BASE_URL = 'companies'

class CompanySSOAPI {

  async getAllCompanies(page) {
    const response = await http(`${BASE_URL}?limit=10&page=${page}`)
    return response || []
  }

  async getCompaniesBySearch(page, search) {
    const response = await http(`${BASE_URL}?limit=10&page=${page}&search=${search}`)
    return response || null
  }
  
  async getCompany(companyId) {
    const { data } = await http(`${BASE_URL}/${companyId}`)
    return data || {}
  }

}

export default new CompanySSOAPI()